import { ProjectBase } from '../components/ProjectBase';
import { ProjectInterface } from '../pages/Projects';
import { ProjectType } from "src/components/ProjectType";
import YoutubeEmbed from '../components/Youtube';

import cover from "../assets/img/izas-supermarket-cover.webp";


export const projectDetails: ProjectInterface = {
    url: "izas-supermarket",
    title: "Izas Supermarket",
    summary: "Simulation game aiding Iza in market management.",
    description: `I joined Iza’s Supermarket as the sole programmer during it’s early development quickly adapting to the project’s requirements and its team, despite the team having grown I remain today working in the project as it’s main programmer.

I developed the majority of the game mechanics, translating the game designers ideas into actual gameplay. Additionally, I created tools to aid our development process, integrated art assets into the game and UI, and incorporated external SDKs and plugins, including cloud data management, in-app purchases and KPIs for data analysis. Furthermore, I’ve also ported a web version of the game.`,
    year: "2023 ~ Today",
    tags: ["Casual", "Management", "Idle", "Mobile", "Unity"],
    imageSrc: cover,
    hasVideo: false,
    startVideoTime: 0,
    videoSrc: "",
    isCoverType: true,
    haveTags: true,
    projectType: ProjectType.PROFESSIONAL,
    roles: ["Programmer"],
    studio: ["Izyplay Game Studio"],
    technologies: ["Unity", "C#", "Mobile"],
    platforms: ["Mobile"],
    collaborators: ["[link=Izyplay Game Studio|https://izyplay.com.br/]"],
    highlightColor: "#60151F",
    descriptionTitle: "",
    linkData: [
        {
            type: 'text', url: "https://play.google.com/store/apps/details?id=com.izyplay.izassupermarket&hl=en_US",
         },
    ],
    relatedProjects: ["ShepherdFarm", "MazeDiscover", "CheckMore"],
};


export function IzasSupermarket() {
    return (
        <div>
            <ProjectBase project={projectDetails}
                useCarousel={false}
                leftContent={
                    <div className="a-left-no-bg">
                        <YoutubeEmbed embedId="Kbw8KrBdjS0" />
                    </div>
                }
                rightContent={
                    null
                }>
            </ProjectBase>
        </div>
    );
}